const DEFAULT_TITLE_SUFFIX = 'BlueBear';
const DEFAULT_TITLE_LIMIT = 60;

/**
 * Keep the editorial headline intact. Add a brand suffix only when the complete
 * search title stays within the display budget; otherwise the headline carries
 * the result on its own. Priority articles may provide a shorter `seoTitle`
 * without changing the visible H1.
 */
export function articleSeoTitle(post, suffix = DEFAULT_TITLE_SUFFIX, limit = DEFAULT_TITLE_LIMIT) {
  const title = String(post?.seoTitle || post?.title || '').trim();
  const titleSuffix = String(suffix || '').trim();
  if (!titleSuffix) return title;
  const branded = `${title} | ${titleSuffix}`;
  return branded.length <= limit ? branded : title;
}

/** Keep visible answer copy separate from a deliberately concise SERP summary. */
export function articleSeoDescription(post) {
  return String(post?.seoDescription || post?.summary || '').trim();
}
